import css from 'styled-jsx/css';
import { warmGrays } from 'styles/colors/constants';
import { MQ_MEDIUM, MQ_LARGE } from 'constants/mq';

export default css`
  .SiteHeaderNavBlock {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1rem;
  }

  .SiteHeaderNavBlock__heading {
    grid-column: span 2;
    margin-bottom: 1rem;
    border-bottom: 1px solid ${warmGrays[0]};
    padding-bottom: 0.25rem;
    color: ${warmGrays[6]};
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
  }

  .SiteHeaderNavBlock__heading a {
    color: ${warmGrays[7]};
  }

  .SiteHeaderNavBlock__section {
    margin-bottom: 1.5rem;
  }

  .SiteHeaderNavBlock__section-link {
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg2);
    line-height: 1.3;
  }

  .SiteHeaderNavBlock__section-links {
    list-style: none;
  }

  .SiteHeaderNavBlock__section-name {
    margin-bottom: 0.5rem;
    color: ${warmGrays[7]};
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
  }

  .SiteHeaderNavBlock__section-links-item {
    margin-bottom: 0.375rem;
  }

  @media ${MQ_MEDIUM} {
    .SiteHeaderNavBlock {
      grid-template-columns: repeat(3, 1fr);
    }

    .SiteHeaderNavBlock__heading {
      grid-column: span 3;
    }
  }

  @media ${MQ_LARGE} {
    .SiteHeaderNavBlock {
      flex: 0 0 auto;
      grid-template-columns: repeat(5, fit-content(240px));
      grid-column-gap: 0px;
    }

    .SiteHeaderNavBlock__heading {
      display: none;
    }

    .SiteHeaderNavBlock__section {
      padding-right: 2rem;
    }

    .SiteHeaderNavBlock__section-link {
      font-size: var(--fontScaleNeg1);
    }

    .SiteHeaderNavBlock__section-name {
      font-size: var(--baseFontSize);
    }
  }
`;
